import { Button } from '@/components/ui/button';
import type { Event } from '@mr-website/schemas';
import type { ComponentProps, CSSProperties, MouseEvent } from 'react';
import { EVENT_AT_CAPACITY_LABEL, isEventAtCapacity } from './capacity';
import { isUserRegisteredForEvent } from './utils';

interface RsvpAttendButtonProps {
  event: Pick<Event, 'is_online' | 'is_full' | 'max_capacity' | 'rsvp_count' | 'user_rsvp'>;
  isAuthenticated: boolean;
  className?: string;
  style?: CSSProperties;
  size?: ComponentProps<typeof Button>['size'];
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
}

export function RsvpAttendButton({
  event,
  isAuthenticated,
  className,
  style,
  size,
  onClick,
}: RsvpAttendButtonProps) {
  const isRegistered = isUserRegisteredForEvent(event);
  const atCapacity = isEventAtCapacity(event);

  const label = isRegistered
    ? 'Manage RSVP'
    : atCapacity
      ? EVENT_AT_CAPACITY_LABEL
      : isAuthenticated
        ? 'RSVP to Attend'
        : 'Sign in to RSVP';

  return (
    <Button
      size={size}
      className={className}
      style={style}
      disabled={!isRegistered && atCapacity}
      onClick={onClick}
    >
      {label}
    </Button>
  );
}
